package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.unit.dp
import com.essntl.core.utils.viewmodel.State
import com.essntl.uikit.components.button.destructive.EsLargeDestructiveButton
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.input.EsRichInput
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.spinner.EsSpinnerSize
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.richeditor.model.rememberRichTextState

@Composable
fun RewriteWithAIPopup(
    state: State<String>,
    openDialog: Boolean,
    onAcceptDescription: () -> Unit,
    onDismissRequest: () -> Unit,
) {
    val richTextState = rememberRichTextState()

    LaunchedEffect(state.isSuccess) {
        state.data?.let {
            richTextState.setHtml(it)
        }
    }

    if (openDialog) {
        EsDialog(
            title = "Odia AI",
            onDismissRequest = onDismissRequest,
        ) {
            Column(
                verticalArrangement = Arrangement.spacedBy(2.5.spacing),
                modifier = Modifier
                    .padding(
                        vertical = 2.5.spacing,
                        horizontal = 2.5.spacing
                    ),
            ) {

                if (state.isLoading) {
                    Text(
                        text = "We are enhancing the service description 🔮\n" +
                            "It may take some time, based on the original description provided",
                        fontStyle = FontStyle.Italic,
                        style = MaterialTheme.esTypography.p2Medium14,
                        color = MaterialTheme.esColorScheme.primary,
                    )

                    EsSpinner(
                        color = MaterialTheme.esColorScheme.primary,
                        size = EsSpinnerSize.Medium,
                        modifier = Modifier
                            .align(Alignment.CenterHorizontally),
                    )
                } else {
                    Text(
                        text = "🪄Proposed enhanced service description:",
                        style = MaterialTheme.esTypography.p2Medium14,
                        color = MaterialTheme.esColorScheme.primary,
                    )
                }

                EsRichInput(
                    richTextState = richTextState,
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(min = 100.dp),
                )

                Box(
                    modifier = Modifier
                        .background(MaterialTheme.esColorScheme.bgSecondary),
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.Center,
                        modifier = Modifier
                            .fillMaxWidth(),
                    ) {
                        EsLargePrimaryButton(
                            onClick = onAcceptDescription,
                            text = "Accept",
                            enabled = true,
                            loading = state.isLoading,
                            modifier = Modifier
                                .weight(1F),
                        )
                        Spacer(modifier = Modifier.width(width = 1.5.spacing))
                        EsLargeDestructiveButton(
                            onClick = onDismissRequest,
                            text = "Discard",
                            enabled = true,
                            modifier = Modifier
                                .weight(1F),
                        )
                    }
                }
            }
        }
    }
}